// 폰 판정 한 곳 (spec docs/superpowers/specs/2026-09-25-phone-landscape-design.md A.1):
// 폭 ≤768px 이거나, 가로로 돌린 폰(터치 · 높이 ≤500 · 폭 ≤1000). CSS 의 @media 도 같은 문장이고
// server/phone_media_test.go 가 둘을 함께 지킨다 — 모듈은 matchMedia('(max-width: 768px)')·innerWidth
// 비교를 쓰지 않고 이것만 쓴다.
export const PHONE_MEDIA = '(max-width: 768px), (pointer: coarse) and (max-height: 500px) and (max-width: 1000px)';
export const phoneQuery = window.matchMedia(PHONE_MEDIA);
export const isPhone = () => phoneQuery.matches;
